const UI_CONFIG = {
  staging: {
    firebase: {
      apiKey: 'AIzaSyAzgT8YKRykoURttIOBCr7frEX6kUN7JIo',
      authDomain: 'reden-me-staging.firebaseapp.com',
      databaseURL: 'https://reden-me-staging.firebaseio.com',
      projectId: 'reden-me-staging',
      storageBucket: 'reden-me-staging.appspot.com',
      messagingSenderId: '428331253641',
      appId: '1:428331253641:web:636c1f8466d85f42306b58',
      measurementId: 'G-3S2YFWFHT5',
    },
  },
  production: {
    firebase: {
      apiKey: 'AIzaSyA7rOWrvtmxjodg3iIYVrg7WFCwSLGdbY0',
      authDomain: 'reden-me.firebaseapp.com',
      databaseURL: 'https://reden-me.firebaseio.com',
      projectId: 'reden-me',
      storageBucket: 'reden-me.appspot.com',
      messagingSenderId: '59530162114',
      appId: '1:59530162114:web:2b5a21deeb30b6b3e9f05b',
      measurementId: 'G-QR54VQQEXE',
    },
  },
}

export default UI_CONFIG[process.env.NEXT_PUBLIC_DEPLOYMENT_ENV] ||
  UI_CONFIG.staging
